export function fetchCheckLogin() {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/whoami.php`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: 'include', // Include cookies for session
    }
  ).then((response) => {
    // Handle redirects and error responses
    if (!response.ok) {
      throw new Error(`Auth check failed: ${response.status}`);
    }
    return response.json();
  }).catch((error) => {
    // Return error object instead of throwing
    console.warn("Auth check failed:", error.message);
    return { error: true, message: error.message };
  });
}

export function fetchLogin(loginCredential) {
  // Using iframe approach for React integration
  // This function is used by Redux, but ModalLogin uses handleWHMCSLogin directly
  const apiUrl = `${process.env.REACT_APP_BASE_API}order/apis/loginAccountFinalIframe.php`;
  
  return fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    credentials: 'include', // Include cookies for session
    body: JSON.stringify({
      email: loginCredential[0],
      password: loginCredential[1],
    }),
  })
  .then((response) => response.json())
  .then((data) => {
    // console.log('Login Response:', data); // Log response
    return data;
  });
}

export function fetchForgotPassword(email) {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/resetPasswordAccount.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        email: email
      })
    }
  ).then((response) => response.json());
}

export function fetchRegister(registerCredential) {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/registerAccount.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        firstname: registerCredential.firstname,
        lastname: registerCredential.lastname,
        email: registerCredential.email,
        address1: registerCredential.address1,
        address2: registerCredential.address2,
        city: registerCredential.city,
        state: registerCredential.state,
        postcode: registerCredential.postcode,
        country: registerCredential.country,
        phonenumber: registerCredential.phonenumber,
        password: registerCredential.password,
        password2: registerCredential.password2,
        company: registerCredential.company,
        currency: registerCredential.currency,
        customfield: registerCredential.customfield
      }),
    }
  ).then((response) => response.json());
}
